const returnUrl = (context = window) => context.lta.imin.paymentUrl;
import { getIminElementInstance } from './imin';
const iminElement = getIminElementInstance('imin');
export function handleConfirmPaymentResponse() {
	const paymentConfirmationEndpoint = `${returnUrl()}`;
	return iminElement._stripe.confirmPayment({
		elements: iminElement.elements,
		confirmParams: {
			return_url: paymentConfirmationEndpoint,
			payment_method_data: {
				billing_details: {
					address: {
						country: 'GB'
					}
				}
			}
		}
	});
}
